import React from 'react';
import PropTypes from 'prop-types';
import {
  LayoutContainer,
  Layout,
  StepContainer,
} from '@bingads-webui-react/wizard';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { CardFooter, SaveBlocker } from '@bingads-webui-react/wizard-ui-library';

const EmptyComponent = () => null;

const getStyles = () => ({
  '@global': {
    '.default-layout': {
      '& .main-container': {
        flexDirection: 'column',
      },
      '& .step-content-and-footer': {
        overflow: 'hidden',
        height: 'auto',
      },
      '& .step-content-container': {
        overflow: 'auto',
      },
    },
  },
});

export const CustomLayoutContainer = ({
  template,
  Footer,
  StepList,
  stepListProps,
  InlineSupport,
}) => {
  useDefaultStyles(getStyles);
  return (
    <LayoutContainer template={template}>
      <Layout type="StepList" component={StepList} {...stepListProps} />
      <Layout type="StepContainer" component={StepContainer} />
      <Layout type="Footer" component={Footer} />
      <Layout type="Blocker" component={SaveBlocker} />
      <Layout type="LoadingShimmer" component={EmptyComponent} />
      <Layout type="CardFooter" component={CardFooter} />
      <Layout type="CardTail" component={InlineSupport} />
    </LayoutContainer>
  );
};

CustomLayoutContainer.propTypes = {
  Footer: PropTypes.func.isRequired,
  StepList: PropTypes.func.isRequired,
  stepListProps: PropTypes.shape({}).isRequired,
  template: PropTypes.func.isRequired,
  InlineSupport: PropTypes.func,
};

CustomLayoutContainer.defaultProps = {
  InlineSupport: EmptyComponent,
};

